var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 103,
    viewBox: "0 0 64 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3684,
    y: 6.84229,
    width: 5.47368,
    height: 52,
    fill: "#F4F3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6842,
    y: 6.84229,
    width: 5.47368,
    height: 52,
    fill: "#F4F3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 6.84229,
    width: 6.84211,
    height: 12.3158,
    fill: "#D9D6FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6842,
    y: 6.84229,
    width: 6.84211,
    height: 12.3158,
    fill: "#D9D6FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2632,
    width: 6.84211,
    height: 38.3158,
    transform: "rotate(90 51.2632 0)",
    fill: "#ACA6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 64,
    height: 79,
    rx: 8.21053,
    fill: "#D9D6FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 39,
    width: 2,
    height: 79,
    rx: 1,
    fill: "#CBC7FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 39,
    width: 2,
    height: 79,
    rx: 1,
    fill: "#CBC7FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 39,
    width: 2,
    height: 79,
    rx: 1,
    fill: "#CBC7FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 39,
    width: 2,
    height: 79,
    rx: 1,
    fill: "#CBC7FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 39,
    width: 2,
    height: 79,
    rx: 1,
    fill: "#CBC7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.6c81f46f1783667230b81fa527da1e8a.svg";
export { ForwardRef as ReactComponent };